module.exports = __webpack_public_path__ + "img/math_creator_logo.572443d2.svg";